<template>
  <div class="gallery">
    <div class="container">
      <div class="row">
        <div class="col s12 m4" v-for="project in projects" :key="project.id">
          <div class="card" @click="go(project.link)">
            <div class="card-image">
              <img :src="project.avatar" class="img-responsive" />
              <span>{{ project.title }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { computed, reactive } from "vue";
import { useHead } from "@vueuse/head";
import { useStore } from "vuex";

export default {
  props: [],
  setup() {
    const siteData = reactive({
      title: `Barakadev | gallery`,
      description: `My beautiful website`,
    });

    useHead({
      // Can be static or computed
      title: computed(() => siteData.title),
      meta: [
        {
          name: `description`,
          content: computed(() => siteData.description),
        },
      ],
    });
    const store = useStore();
    const projects = computed(() => {
      return store.getters.getProjects;
    });
    const go = (e) => {
      window.location.replace(e);
    };
    return {
      projects,
      go,
    };
  },
};
</script>
<style scoped>
.gallery {
  min-height: 100vh;
  margin-top: 55px;
  margin-bottom: 55px;
}
span {
  position: absolute;
  margin-top: -40px;
  color: rgb(46, 45, 45);
  font-size: 18px;
  font-weight: 600;
  padding: 5px;
  padding-left: 15px;
  text-transform: capitalize;
  background-color: #755cd10c;
  width: 100%;
}
.img-responsive {
  width: 100%;
  object-fit: cover;
  height: 200px;
}
</style>
